import { useCallback } from "react";
import { VrReportContentMode } from "./vrReportContentMode";

const VR_REPORT_DOWNLOAD_FILE_NAME = "Verification Report.pdf";

// ADO 4855: downloads the VR results report PDF directly to the reviewer's
// preferred download location, instead of previewing it. Mirrors the
// existing blob -> object URL -> temporary <a download> pattern already used
// by DownloadSampleButton.tsx, reusing viewVrReportSnapshot's blob response
// rather than a separate endpoint.
export const useDownloadVrReport = (dataProvider: any) =>
  useCallback(
    async (trnId: string | number, contentMode?: VrReportContentMode) => {
      const report = await dataProvider.viewVrReportSnapshot({
        trnId,
        openInNewWindow: false,
        content: contentMode,
      });
      const reportUrl = report?.data?.url;
      if (!reportUrl) throw new Error("Failed to download the report");

      const anchor = document.createElement("a");
      anchor.href = reportUrl;
      anchor.download = VR_REPORT_DOWNLOAD_FILE_NAME;
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      window.setTimeout(() => window.URL.revokeObjectURL(reportUrl), 60000);

      return "downloaded" as const;
    },
    [dataProvider]
  );
